<script>
import { formatDate } from '../../../libs/datetime'

export default {
  computed: {
    /**
     * Article authors label
     * @returns {string}
     */
    authorsLabel() {
      if (Array.isArray(this.authors)) {
        return this.authors.join(', ')
      }
      return ''
    },

    /**
     * Article byline
     * @returns {string}
     */
    byline() {
      const bylineLabels = [this.authorsLabel, this.createdDateLabel]
      if (this.lastUpdatedDateLabel) {
        bylineLabels.push(`${this.$t('article.updatedOn')} ${this.lastUpdatedDateLabel}`)
      }

      return bylineLabels.filter((e) => e).join(' | ')
    },

    /**
     * Article created date label
     * @returns {string}
     */
    createdDateLabel() {
      if (this.createdAt) {
        return formatDate(new Date(this.createdAt))
      }
      return ''
    },

    /**
     * Article last updated date label
     * @returns {string}
     */
    lastUpdatedDateLabel() {
      if (this.lastUpdatedAt) {
        return formatDate(new Date(this.lastUpdatedAt))
      }
      return ''
    },
  },
  props: {
    /**
     * Article authors
     */
    authors: {
      default: () => [],
      type: Array,
    },

    /**
     * Article created time
     */
    createdAt: {
      default: '',
      type: String,
    },

    /**
     * Article last updated time
     */
    lastUpdatedAt: {
      default: '',
      type: String,
    },
  },
  render(createEl) {
    // If byline available, render <p>
    if (this.byline) {
      return createEl('p', {
        class: 'article-byline',
        domProps: { innerHTML: this.byline },
      })
    }

    // Otherwise render nothing
    return null
  },
}
</script>
